var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuara3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_845_38559",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5176,
    cy: 32,
    r: 32,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_845_38559)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5176,
    cy: 32,
    r: 32,
    fill: "#B5EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4229 48.4057L22.3763 48.4657C22.104 48.7761 21.7732 49.0298 21.4029 49.2124C21.0872 49.3575 20.7438 49.4326 20.3963 49.4324C20.2238 49.4313 20.0519 49.4134 19.8829 49.3791L21.0629 47.3324C21.4556 46.7849 21.7194 46.1558 21.8349 45.492C21.9503 44.8282 21.9143 44.147 21.7296 43.4991C21.4429 42.6591 20.9163 42.5591 20.7363 42.5257H20.6696C17.4059 41.6308 14.3968 39.9847 11.8829 37.7191C11.4896 37.3657 11.1096 37.0057 10.7429 36.6257C10.3763 36.2457 9.95628 35.7391 9.58294 35.2924C8.73775 34.2788 7.9774 33.1974 7.30961 32.0591C5.38151 28.7703 4.22575 25.0865 3.92961 21.2857L3.84961 20.3391L4.31628 20.0391L14.1829 20.3391L14.1429 21.2524C14.1429 21.2524 14.0629 23.7457 15.4763 25.2524C15.8012 25.6027 16.1935 25.8839 16.6296 26.0791C17.2403 26.3427 17.8978 26.481 18.5629 26.4857L19.0296 28.3924C18.2165 28.3292 17.4122 28.1817 16.6296 27.9524C15.6972 27.6751 14.8552 27.1551 14.1896 26.4457C13.1373 25.2192 12.5104 23.6849 12.4029 22.0724H5.73628C5.98343 24.1321 6.50355 26.1498 7.28294 28.0724C7.89287 29.5884 8.66396 31.0345 9.58294 32.3857C9.94961 32.9324 10.3429 33.4524 10.7496 33.9524C11.1563 34.4524 11.4896 34.8324 11.8896 35.2457C14.3985 37.8942 17.5812 39.8094 21.0963 40.7857C21.2436 40.8147 21.3884 40.8548 21.5296 40.9057C21.9743 41.0719 22.3744 41.339 22.6983 41.686C23.0222 42.0331 23.2612 42.4506 23.3963 42.9057C23.6751 43.8348 23.7323 44.8163 23.5633 45.7714C23.3942 46.7266 23.0037 47.6288 22.4229 48.4057Z",
    fill: "url(#paint0_linear_845_38559)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1834 21.5205L12.4301 22.0939H5.92339L5.63672 21.0605L13.1834 21.5205Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4228 48.4062L22.3761 48.4663C22.1038 48.7766 21.7731 49.0303 21.4028 49.2129C21.0871 49.3581 20.7436 49.4331 20.3961 49.4329C20.2237 49.4318 20.0518 49.4139 19.8828 49.3796L20.3495 49.0796L22.4228 48.4062Z",
    fill: "#6D6D6D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8364 48.1657C22.5627 48.4785 22.2266 48.7306 21.8497 48.9057C21.537 49.0537 21.1957 49.131 20.8497 49.1324C20.6773 49.1313 20.5054 49.1134 20.3364 49.0791L21.5164 47.0057C21.9086 46.458 22.1722 45.8289 22.2876 45.1652C22.403 44.5015 22.3673 43.8204 22.1831 43.1724C21.9164 42.3324 21.3897 42.2324 21.1831 42.1991H21.1164C17.8527 41.3041 14.8436 39.6581 12.3297 37.3924C11.9364 37.0391 11.5564 36.6724 11.1897 36.2991C10.8231 35.9257 10.4231 35.4391 10.0497 34.9924C9.20454 33.9788 8.4442 32.8974 7.77641 31.7591C5.84916 28.4695 4.69136 24.7864 4.38974 20.9857L4.31641 20.0391H14.6497L14.6097 20.9524C14.6097 20.9524 14.5297 23.4457 15.9431 24.9524C16.2668 25.3041 16.6594 25.5855 17.0964 25.7791C17.7069 26.0434 18.3645 26.1817 19.0297 26.1857L18.9897 27.9324C18.3491 27.9222 17.7126 27.828 17.0964 27.6524C16.1624 27.3753 15.3197 26.8527 14.6564 26.1391C13.6041 24.9119 12.9753 23.3784 12.8631 21.7657H6.19641C6.44641 23.8249 6.96644 25.8423 7.74307 27.7657C8.35612 29.2837 9.12939 30.7319 10.0497 32.0857C10.4164 32.6257 10.8031 33.1524 11.2164 33.6524C11.6297 34.1524 11.9564 34.5324 12.3564 34.9391C14.8649 37.5894 18.0476 39.5069 21.5631 40.4857C21.7089 40.5115 21.8518 40.5517 21.9897 40.6057C22.4365 40.7696 22.8386 41.0359 23.164 41.3832C23.4893 41.7305 23.7287 42.1492 23.8631 42.6057C24.1455 43.5474 24.1998 44.5429 24.0212 45.5097C23.8427 46.4766 23.4366 47.387 22.8364 48.1657Z",
    fill: "url(#paint1_linear_845_38559)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8363 48.1674C22.5626 48.4802 22.2265 48.7323 21.8496 48.9074C23.6563 45.6808 22.6763 42.2408 21.9763 40.6074C22.423 40.7713 22.8252 41.0376 23.1505 41.3849C23.4758 41.7322 23.7152 42.1509 23.8496 42.6074C24.1339 43.5481 24.1903 44.543 24.0141 45.5097C23.8379 46.4765 23.4342 47.3875 22.8363 48.1674Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.123 25.8008C17.7335 26.0651 18.3911 26.2035 19.0564 26.2074L19.0164 27.9541C18.3757 27.9439 17.7392 27.8498 17.123 27.6741V25.8008Z",
    fill: "#6D6D6D"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9768 20.3409L60.8968 21.2876C60.6309 24.6981 59.6737 28.0188 58.0835 31.0476C57.7702 31.6409 57.4168 32.2076 57.0902 32.7676C56.7635 33.3276 56.3702 33.8476 55.9835 34.3676C55.3536 35.1982 54.67 35.9865 53.9368 36.7276C51.2431 39.4815 47.8655 41.4694 44.1502 42.4876H44.0835C43.9035 42.4876 43.3768 42.6209 43.0835 43.4609C42.7762 44.5741 42.8926 45.7618 43.4102 46.7942C43.5099 46.9791 43.6283 47.1534 43.7635 47.3142L45.6368 49.0876L44.9702 49.3876C44.8012 49.4219 44.6293 49.4397 44.4568 49.4409C44.1904 49.4517 43.9241 49.4156 43.6702 49.3342C43.4178 49.2446 43.1797 49.1189 42.9635 48.9609C42.7781 48.8218 42.6063 48.6655 42.4502 48.4942C41.853 47.7126 41.4493 46.8008 41.272 45.8333C41.0947 44.8658 41.1489 43.8701 41.4302 42.9276C41.571 42.449 41.8269 42.0122 42.1756 41.6554C42.5242 41.2986 42.955 41.0327 43.4302 40.8809L43.7035 40.8142C47.7111 39.6962 51.2757 37.3679 53.9102 34.1476C54.6679 33.2364 55.3523 32.2667 55.9568 31.2476C56.3612 30.5646 56.7306 29.8614 57.0635 29.1409C57.4399 28.3081 57.7715 27.4558 58.0568 26.5876C58.5243 25.1308 58.8525 23.633 59.0368 22.1142H52.3702C52.2627 23.7267 51.6359 25.2611 50.5835 26.4876C49.915 27.2047 49.065 27.7276 48.1235 28.0009C47.5229 28.174 46.9018 28.2659 46.2768 28.2742L46.2368 26.5276C46.8848 26.5221 47.5256 26.3908 48.1235 26.1409C48.5806 25.9433 48.9915 25.6527 49.3302 25.2876C50.7502 23.7742 50.6635 21.2876 50.6635 21.2876L50.6235 20.3742L51.2902 20.0742L60.9768 20.3409Z",
    fill: "url(#paint2_linear_845_38559)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8834 21.6939L59.0634 22.0939H52.4434V21.2539L59.8834 21.6939Z",
    fill: "#6D6D6D"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6702 20.0391L61.5902 20.9857C61.321 24.3965 60.3616 27.717 58.7702 30.7457C58.4569 31.3391 58.1035 31.9057 57.7769 32.4657C57.4502 33.0257 57.0569 33.5457 56.6702 34.0657C56.0426 34.8962 55.3612 35.6846 54.6302 36.4257C51.9355 39.1784 48.5582 41.1661 44.8435 42.1857H44.7702C44.5969 42.2191 44.0702 42.3191 43.7769 43.1591C43.4695 44.2723 43.5859 45.46 44.1035 46.4924C44.1993 46.6817 44.318 46.8586 44.4569 47.0191L45.6369 49.0924C45.4677 49.1259 45.2959 49.1438 45.1235 49.1457C44.8626 49.147 44.6034 49.1042 44.3569 49.0191C44.1035 48.9288 43.8652 48.8006 43.6502 48.6391C43.4641 48.5058 43.2941 48.3515 43.1435 48.1791C42.5417 47.3973 42.1346 46.4834 41.9561 45.5131C41.7776 44.5428 41.8327 43.5439 42.1169 42.5991C42.2603 42.1165 42.5211 41.677 42.8759 41.3198C43.2307 40.9626 43.6685 40.699 44.1502 40.5524C44.2372 40.5232 44.3263 40.5009 44.4169 40.4857C48.426 39.3669 51.9925 37.0389 54.6302 33.8191C55.3857 32.9101 56.0678 31.9426 56.6702 30.9257C57.0759 30.2412 57.4453 29.5358 57.7769 28.8124C58.1601 27.9848 58.4918 27.1343 58.7702 26.2657C59.2447 24.8086 59.573 23.3079 59.7502 21.7857H53.0835C52.9746 23.3991 52.3454 24.9337 51.2902 26.1591C50.6167 26.8846 49.7563 27.4105 48.8035 27.6791C48.2051 27.8516 47.5863 27.9435 46.9635 27.9524L46.9235 26.2057C47.5693 26.1996 48.2078 26.0683 48.8035 25.8191C49.2636 25.6233 49.6771 25.3325 50.0169 24.9657C51.4369 23.4524 51.3502 20.9657 51.3502 20.9657L51.3102 20.0524L61.6702 20.0391Z",
    fill: "url(#paint3_linear_845_38559)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6493 48.6261C43.4632 48.4928 43.2931 48.3385 43.1426 48.1661C42.5428 47.3858 42.137 46.4742 41.9585 45.5064C41.78 44.5386 41.834 43.5423 42.1159 42.5994C42.2594 42.1168 42.5202 41.6773 42.875 41.3201C43.2298 40.963 43.6676 40.6993 44.1493 40.5527C43.3826 41.9994 42.1026 45.2794 43.6493 48.6261Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8097 25.8203V27.6803C48.2112 27.8529 47.5924 27.9448 46.9697 27.9536L46.9297 26.207C47.5755 26.2009 48.2139 26.0696 48.8097 25.8203Z",
    fill: "#6D6D6D"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7685 18.873C47.7685 19.6197 47.7685 20.3997 47.7152 21.213C47.7152 21.553 47.7152 21.8797 47.6618 22.2597C47.36 27.8368 46.3382 33.3514 44.6218 38.6664C42.2752 45.473 38.5152 50.913 32.8885 50.913C22.8218 50.913 18.6752 33.4664 18.0818 21.7397C18.0818 21.5664 18.0818 21.3864 18.0818 21.213C18.0818 20.3997 18.0352 19.6197 18.0352 18.873H47.7685Z",
    fill: "url(#paint4_linear_845_38559)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0239 32.3131C36.653 31.9496 36.1933 31.6898 35.6906 31.5597C35.5678 31.5238 35.4432 31.4949 35.3172 31.4731V31.3797C35.5859 31.3041 35.8471 31.2036 36.0972 31.0797C36.367 30.9447 36.6162 30.7718 36.8372 30.5664C37.0515 30.362 37.2213 30.1156 37.336 29.8426C37.4507 29.5696 37.5078 29.2758 37.5039 28.9797C37.4885 28.6156 37.3846 28.2608 37.201 27.9459C37.0174 27.6311 36.7599 27.3658 36.4506 27.1731C35.6036 26.7026 34.6362 26.4938 33.6706 26.5731C32.5822 26.5579 31.4995 26.7316 30.4706 27.0864C30.4706 27.1731 30.0972 27.4664 30.0972 27.5531C30.0937 27.6019 30.0937 27.6509 30.0972 27.6997V27.8064C30.0972 28.4731 30.3706 28.9864 30.3439 29.6797C30.579 29.7362 30.7951 29.8535 30.9706 30.0197C31.1449 30.1748 31.3601 30.2766 31.5906 30.3131C31.6506 30.3131 31.9039 29.8531 31.9639 29.8531V29.6997L32.2239 28.5997L32.2706 28.3997C32.2725 28.3737 32.2809 28.3485 32.2948 28.3264C32.3088 28.3044 32.3279 28.286 32.3506 28.2731H32.3839C32.6441 28.0976 32.9501 28.0026 33.2639 27.9997C33.4748 27.9741 33.6888 27.9955 33.8905 28.0623C34.0923 28.1292 34.2767 28.2399 34.4306 28.3864C34.6361 28.625 34.7455 28.9316 34.7372 29.2464C34.7515 29.4684 34.7117 29.6906 34.6211 29.8939C34.5305 30.0971 34.3919 30.2753 34.2172 30.4131C33.9036 30.6415 33.5404 30.7923 33.1572 30.8531C32.6608 30.9489 32.1561 30.9958 31.6506 30.9931C31.6506 30.9931 31.6506 30.9931 31.6506 31.0397C31.6506 31.0864 31.2972 31.3997 31.2972 31.4531C31.2972 31.8597 31.6639 32.0664 31.7172 32.4464C31.7172 32.4464 31.7172 32.4797 31.7172 32.4931H32.6172C32.7882 32.4827 32.9596 32.4827 33.1306 32.4931C34.1506 32.6264 34.8506 33.1597 34.8506 34.1131V34.2131C34.8332 34.4472 34.7649 34.6747 34.6506 34.8797C34.6006 34.9746 34.5378 35.062 34.4639 35.1397L34.3839 35.2131L34.3172 35.2731C33.912 35.5425 33.4295 35.6713 32.9439 35.6397C32.7144 35.633 32.4883 35.5833 32.2772 35.4931C32.2478 35.4787 32.2219 35.4582 32.2012 35.4329C32.1804 35.4075 32.1655 35.378 32.1572 35.3464L31.7906 33.8264H31.7372L30.5106 34.0197L30.1106 34.0931C30.1106 34.1797 29.7239 34.4797 29.7306 34.5597C29.8239 35.3997 30.3306 36.0397 30.4506 36.8931C30.642 36.9337 30.8356 36.9626 31.0306 36.9797C31.5638 37.0422 32.1004 37.0711 32.6372 37.0664C32.9439 37.0664 33.2372 37.0664 33.5172 37.0664C34.3148 37.0577 35.1046 36.9088 35.8506 36.6264C36.0373 36.5446 36.214 36.4417 36.3772 36.3197C36.4706 36.2531 36.5639 36.1797 36.6572 36.0997L36.7039 36.0597C36.7906 35.9864 36.8639 35.9131 36.9439 35.8331C37.1447 35.6402 37.3115 35.4148 37.4372 35.1664C37.6385 34.7822 37.7394 34.3534 37.7306 33.9197C37.7289 33.6178 37.6654 33.3195 37.5438 33.0431C37.4223 32.7668 37.2453 32.5183 37.0239 32.3131Z",
    fill: "#5D2A14"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7499 32.874C36.2561 32.3674 35.6097 32.0372 34.9099 31.934V31.8407C35.1649 31.7646 35.4144 31.6711 35.6565 31.5607C36.1252 31.345 36.5229 31.0005 36.8032 30.5673C37.0083 30.2301 37.1146 29.842 37.1099 29.4473C37.0944 29.0823 36.9905 28.7266 36.807 28.4107C36.6235 28.0948 36.366 27.8282 36.0565 27.634C35.2096 27.1636 34.2421 26.9548 33.2765 27.034C32.1876 27.0174 31.1042 27.1934 30.0765 27.554C30.0731 27.6028 30.0731 27.6518 30.0765 27.7007C30.0732 27.7295 30.0732 27.7585 30.0765 27.7873C30.0365 28.3273 30.0099 28.874 29.9899 29.4207C29.9899 29.6673 29.9899 29.9007 29.9899 30.1407C30.2632 30.1807 30.5565 30.2207 30.8432 30.2473L31.6099 30.314L31.8032 29.4873L31.9499 28.8673C31.9528 28.8407 31.9615 28.8149 31.9753 28.7919C31.9891 28.7689 32.0077 28.7492 32.0299 28.734C32.1044 28.6766 32.1877 28.6315 32.2765 28.6007C32.4904 28.5246 32.7163 28.4884 32.9432 28.494C33.1532 28.467 33.3666 28.4877 33.5674 28.5547C33.7683 28.6216 33.9514 28.7331 34.1032 28.8807C34.3113 29.1151 34.4211 29.4207 34.4099 29.734C34.4164 29.977 34.3685 30.2185 34.2699 30.4407C34.1063 30.7696 33.8221 31.0227 33.4765 31.1473C33.0233 31.3271 32.5435 31.4307 32.0565 31.454C31.8365 31.454 31.5899 31.454 31.3232 31.454C31.3232 31.6407 31.3232 31.8407 31.3232 32.0407C31.3232 32.3473 31.3232 32.6673 31.3632 32.9607H32.2699C33.5632 32.9607 34.5032 33.5073 34.5032 34.6073C34.5043 34.786 34.4773 34.9637 34.4232 35.134C34.4035 35.2032 34.3767 35.2703 34.3432 35.334C34.2691 35.4886 34.1648 35.6269 34.0365 35.7407C33.6232 36.0504 33.1116 36.1996 32.5965 36.1607C32.3673 36.1526 32.1414 36.1029 31.9299 36.014C31.9024 35.9996 31.8782 35.9798 31.8587 35.9557C31.8392 35.9317 31.8249 35.9038 31.8165 35.874L31.6565 35.2073L31.4432 34.3473L30.9032 34.4273C30.5165 34.4873 30.1365 34.554 29.7832 34.6207C29.8765 35.4673 29.9765 36.3207 30.0965 37.1873C30.0965 37.2607 30.0965 37.3407 30.0965 37.414C30.8224 37.5446 31.5591 37.6048 32.2965 37.594C32.8152 37.6039 33.334 37.5816 33.8499 37.5273C34.6062 37.4569 35.334 37.2029 35.9699 36.7873C36.2283 36.5906 36.4651 36.3672 36.6765 36.1207C36.7612 36.0215 36.8391 35.9168 36.9099 35.8073C37.0771 35.5589 37.1948 35.2804 37.2565 34.9873C37.3017 34.768 37.324 34.5446 37.3232 34.3207C37.3147 33.7847 37.1108 33.2703 36.7499 32.874Z",
    fill: "#843C1D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6236 38.6664C42.9303 43.573 40.517 47.7797 37.1836 49.7397C35.8961 50.5095 34.4237 50.915 32.9236 50.913C22.857 50.913 18.7103 33.4664 18.117 21.7397C18.117 21.5664 18.117 21.3864 18.117 21.213C18.117 20.3997 18.0703 19.6197 18.0703 18.873H27.417L26.9703 20.5664C26.9703 20.5664 28.357 53.8264 44.6236 38.6664Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4617 49.5464C25.7617 45.253 21.695 26.7397 20.515 18.873H18.875C18.875 19.6197 18.875 20.3997 18.9283 21.213C18.9283 21.3864 18.9283 21.5664 18.9283 21.7464C19.515 33.293 23.5483 50.413 33.295 50.8997L37.4617 49.5464Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7698 18.873C47.7698 19.6197 47.7698 20.3997 47.7164 21.213C47.7164 21.553 47.7164 21.8797 47.6631 22.2597C41.0836 21.5387 34.4686 21.1892 27.8498 21.213C21.6631 21.213 19.0831 21.473 18.0564 21.7397C18.0564 21.5664 18.0564 21.3864 18.0564 21.213C18.0564 20.3997 18.0098 19.6197 18.0098 18.873H47.7698Z",
    fill: "#6D6D6D"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6292 18L49.3826 18.8267L48.9359 20.3333H16.8426L16.1426 18H49.6292Z",
    fill: "url(#paint5_linear_845_38559)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8973 51.927L37.624 52.1604C37.2429 52.4921 36.8885 52.8532 36.564 53.2404C36.3235 53.4943 36.1655 53.815 36.1106 54.1604C36.1166 55.1205 35.9864 56.0767 35.724 57.0004C35.6352 57.3168 35.5238 57.6265 35.3906 57.927L35.3373 58.0604C35.2773 58.1737 35.224 58.2937 35.164 58.4004C34.584 59.487 33.7773 60.1604 32.8906 60.1604C32.3939 60.1434 31.9201 59.9468 31.5573 59.607C31.0831 59.1771 30.7078 58.6494 30.4573 58.0604C29.9252 56.8301 29.6615 55.5006 29.684 54.1604C29.684 53.367 27.8906 51.927 27.8906 51.927V51.887L28.5573 49.707H37.184L37.5306 50.8137L37.784 51.6137L37.8706 51.887L37.8973 51.927Z",
    fill: "#C27337"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.884 51.887H27.8906L28.5773 49.707H37.1973L37.544 50.8137L37.7973 51.6137L37.884 51.887Z",
    fill: "url(#paint6_linear_845_38559)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5417 59.607C30.435 58.6604 29.6683 56.5804 29.6683 54.1604C29.6683 53.367 27.875 51.927 27.875 51.927L28.575 49.707H37.1817C37.1817 49.707 28.4417 50.1004 30.415 52.1737C30.5417 52.527 31.9417 52.6137 31.9417 52.6137C31.9417 52.6137 30.6083 57.6804 32.3817 58.0604C33.235 58.2337 32.515 58.9337 31.5417 59.607Z",
    fill: "#6D6D6D"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9229 60.1605H29.8496L30.4429 58.0605H35.3363L35.4829 58.6005L35.8496 59.8805L35.9229 60.1605Z",
    fill: "url(#paint7_linear_845_38559)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3226 75.0935H28.4492L29.8492 60.1602H35.9226L35.9492 60.4468L37.3226 75.0935Z",
    fill: "#C27337"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8957 51.9258L37.6224 52.1592C35.7757 52.1592 33.1891 52.0458 32.2891 52.0325C32.7959 52.0126 33.3012 51.9637 33.8024 51.8858C35.0842 51.6548 36.3394 51.2952 37.5491 50.8125L37.8024 51.6125L37.8891 51.8858L37.8957 51.9258Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9486 60.4475L31.8086 60.1609L35.8086 59.8809L35.9019 60.1609L35.9486 60.4475Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6301 18L49.3834 18.8267L24.6367 18H49.6301Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3963 58.0605L31.8829 60.1605H29.8496L30.4429 58.0605H32.3963Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8826 60.1602L31.1425 75.0935H30.9826H28.4492L29.8492 60.1602H31.8826Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6891 20.3333H16.8424L16.1758 18H22.1224C21.4491 18.4267 19.5891 20.1267 30.6891 20.3333Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8492 20.3333H16.8426L16.1426 18H17.8226L18.8492 20.3333Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M28.17 36.8526C28.17 36.8526 25.0233 29.5926 25.6367 22.5859H22.75C22.75 22.5859 23.4833 32.1326 28.17 36.8526Z",
    fill: "url(#paint8_linear_845_38559)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M38.1953 40.4393C38.2104 40.3667 38.2104 40.2918 38.1953 40.2193C38.3153 38.1593 38.1953 22.5859 38.1953 22.5859H46.4553C46.4553 22.5859 46.602 39.1259 38.1953 40.4393Z",
    fill: "url(#paint9_linear_845_38559)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9102 40.7009C38.0368 38.6476 37.9102 23.0742 37.9102 23.0742H41.1835C41.1835 26.7009 40.8502 36.3742 37.9102 40.7009Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1106 18H32.8906V20.3333H39.1106V18Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2564 18H40.623V20.3333H42.2564V18Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 20.0391H54.6289V21.7924H56.6689V20.0391Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 30.9258V34.0658C56.0414 34.8963 55.3599 35.6847 54.6289 36.4258V33.8191C55.3844 32.9102 56.0666 31.9427 56.6689 30.9258Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7707 20.0391H57.7773V21.7924H58.7707V20.0391Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7707 26.2676V30.7476C58.4573 31.3409 58.104 31.9076 57.7773 32.4676V28.8142C58.1606 27.9866 58.4923 27.1361 58.7707 26.2676Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0507 20.0391H7.77734V21.7924H10.0507V20.0391Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0507 32.0866V34.9933C9.20548 33.9797 8.44514 32.8983 7.77734 31.76V27.8066C8.38237 29.3093 9.14438 30.744 10.0507 32.0866Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3568 20.0391H11.2168V21.7924H12.3568V20.0391Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3568 34.941V37.381C11.9635 37.0276 11.5835 36.661 11.2168 36.2876V33.6543C11.5768 34.101 11.9568 34.5343 12.3568 34.941Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6368 49.0805C45.4677 49.114 45.2959 49.1319 45.1235 49.1338C44.8626 49.1351 44.6034 49.0923 44.3568 49.0071C44.1946 48.1745 44.1098 47.3287 44.1035 46.4805C44.1993 46.6698 44.318 46.8467 44.4568 47.0071L45.6368 49.0805Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5561 75.0933H33.8828L34.5295 63.4199L36.5561 75.0933Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1235 75.0933H32.7168V63.4199L33.1235 75.0933Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3438 53.7069C34.1704 54.1336 35.8704 55.9869 34.2104 57.8802C33.9261 57.9603 33.6365 58.0205 33.3438 58.0602C33.9742 58.0422 34.6014 58.1581 35.1837 58.4002C35.2979 58.4541 35.4053 58.5212 35.5037 58.6002L35.3571 58.0602L35.4104 57.9269C35.4104 57.8669 35.4637 57.8002 35.4837 57.7402C35.5189 57.6664 35.55 57.5907 35.5771 57.5136C35.6371 57.3536 35.6904 57.1802 35.7437 57.0002C36.0062 56.0766 36.1364 55.1204 36.1304 54.1602C36.1853 53.8149 36.3433 53.4941 36.5837 53.2402C35.5334 53.5582 34.4411 53.7155 33.3438 53.7069Z",
    fill: "#6D6D6D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_845_38559",
    x1: 22.0629,
    y1: 33.6791,
    x2: -4.63706,
    y2: 36.6057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_845_38559",
    x1: 17.7964,
    y1: 35.5324,
    x2: 1.24974,
    y2: 10.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C15F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_845_38559",
    x1: 41.1635,
    y1: 34.7409,
    x2: 60.9768,
    y2: 34.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_845_38559",
    x1: 41.8569,
    y1: 34.5857,
    x2: 61.6702,
    y2: 34.5857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C15F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_845_38559",
    x1: 18.0085,
    y1: 34.893,
    x2: 47.7685,
    y2: 34.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_845_38559",
    x1: 16.1426,
    y1: 19.1667,
    x2: 49.6292,
    y2: 19.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_845_38559",
    x1: 27.8906,
    y1: 50.7937,
    x2: 37.884,
    y2: 50.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C25439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_845_38559",
    x1: 30.0896,
    y1: 59.1472,
    x2: 39.0763,
    y2: 59.0339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3593F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_845_38559",
    x1: 22.75,
    y1: 29.7193,
    x2: 28.17,
    y2: 29.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_845_38559",
    x1: 38.1953,
    y1: 31.5126,
    x2: 46.4553,
    y2: 31.5126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuara3);
export default __webpack_public_path__ + "static/media/juara-3.21ebd8bc6182dbfce92d4cabbbbc4169.svg";
export { ForwardRef as ReactComponent };